export default __webpack_public_path__ + "static/media/down.82961b46.png";